import React, { useState } from "react";
import "./HaversineCalculator.css"; // Add styles

const toRadians = (degrees) => (degrees * Math.PI) / 180;

const haversineDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of Earth in KM

  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in KM
};

const HaversineCalculator = () => {
  const [point1, setPoint1] = useState("");
  const [point2, setPoint2] = useState("");
  const [distance, setDistance] = useState(null);

  const handleCalculate = () => {
    if (!point1 || !point2) {
      alert("Please enter both points.");
      return;
    }

    const [lat1, lon1] = point1.split(/[, ]+/).map(Number);
    const [lat2, lon2] = point2.split(/[, ]+/).map(Number);

    if (isNaN(lat1) || isNaN(lon1) || isNaN(lat2) || isNaN(lon2)) {
      alert("Invalid coordinates! Please enter valid latitude and longitude.");
      return;
    }

    const dist = haversineDistance(lat1, lon1, lat2, lon2);
    setDistance(dist.toFixed(2));
  };

  return (
    <div className="container">
      <div className="card">
        <h2>Haversine Distance Calculator</h2>
        <p>Enter two geographic points to calculate the distance between them.</p>

        <input
          type="text"
          placeholder="Enter Point 1 (lat, long)"
          value={point1}
          onChange={(e) => setPoint1(e.target.value)}
        />

        <input
          type="text"
          placeholder="Enter Point 2 (lat, long)"
          value={point2}
          onChange={(e) => setPoint2(e.target.value)}
        />

        <button onClick={handleCalculate}>Calculate Distance</button>

        {distance !== null && (
          <div className="result">
            <h3>Distance: {distance} km</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default HaversineCalculator;